<template>
  <div class="table-responsive">
    <b-table striped hover :items="words" :fields="fields" responsive="sm" class="mb-0">
      <template #cell(key)="data">
        <b-form-input
          v-model="data.item.key"
          :placeholder="$t('TRANSLATION_CONFIG.Key')"
          class="mb-0"
          size="sm"
        ></b-form-input>
      </template>

      <template #cell(meaning)="data">
        <b-form-input
          v-model="data.item.meaning"
          :placeholder="$t('TRANSLATION_CONFIG.Meaning')"
          class="mb-0"
          size="sm"
        ></b-form-input>
      </template>

      <template #cell(actions)="data">
        <b-button
          variant="danger"
          size="sm"
          @click="$emit('remove', data.index)"
        >
          {{ $t('TRANSLATION_CONFIG.Remove') }}
        </b-button>
      </template>

      <template #empty>
        <tr>
          <td colspan="3" class="text-center text-muted">
            {{ $t('TRANSLATION_CONFIG.NoTerms') }}
          </td>
        </tr>
      </template>
    </b-table>
  </div>
</template>



<script>
import { BTable, BFormInput, BButton } from 'bootstrap-vue';

export default {
  components: {
    BTable,
    BFormInput,
    BButton
  },
  name: 'WordsList',
  props: {
    words: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        { key: 'key', label: this.$t('TRANSLATION_CONFIG.Key') },
        { key: 'meaning', label: this.$t('TRANSLATION_CONFIG.Meaning') },
        { key: 'actions', label: this.$t('TRANSLATION_CONFIG.Actions'), class: 'text-end' }
      ]
    }
  }
}
</script>

<style scoped>
.table-responsive {
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
